import React, { useState } from 'react'
import { FormattedMessage, useIntl } from 'react-intl'

import s from './styles.module.scss'

import ItemHouseEquipment from '../item-house-equipment/item-house-equipment'
import { EquipmentCategoryEnum } from '../../../../lib/graphql'
import { Card } from '../../../layout'
import { Modal } from '../../../molecules'

const CategoryHouseEquipment = ({
  title,
  equipments,
  viewMore,
  className,
}: {
  title: React.ReactNode
  equipments: {
    _id: string
    label: string
    icon: string
    category: EquipmentCategoryEnum
  }[]
  viewMore?: boolean
  className?: string
}) => {
  const intl = useIntl()
  const [openModal, setIsOpenModal] = useState<boolean>(false)

  if (equipments.length === 0) {
    return null
  }

  const displayedEquipments =
    viewMore && equipments.length > 3 ? equipments.slice(0, 3) : equipments

  return (
    <Card className={className} title={title}>
      <div className={s.gridEquipments}>
        {displayedEquipments.map((equipment) => {
          return (
            <ItemHouseEquipment key={equipment._id} equipment={equipment} />
          )
        })}
      </div>

      {viewMore && equipments.length > 3 && (
        <div className={s.viewMore} onClick={() => setIsOpenModal(true)}>
          <FormattedMessage
            id='ui.CategoryHouseEquipment.seeAllEquipments'
            defaultMessage='Voir tous les équipements'
          />
        </div>
      )}

      {viewMore && equipments.length > 3 && (
        <Modal
          title={intl.formatMessage({
            id: 'ui.CategoryHouseEquipment.otherEquipments',
            defaultMessage: 'Les autres équipements du lieu',
          })}
          isOpen={openModal}
          closeModal={() => setIsOpenModal(false)}
        >
          {equipments.map((equipment) => (
            <ItemHouseEquipment
              key={equipment._id}
              equipment={equipment}
              className={s.modalEquipment}
            />
          ))}
        </Modal>
      )}
    </Card>
  )
}

export default CategoryHouseEquipment
